import api from '../../../App/socket';

export const updateLeadsAffiliate = (_id, key, value) => (
    api.send({
        api: 'db',
        model: 'Lead_affiliate',
        action: 'Update',
        options: {
            update: {
                [key]: value,
            },
            where: {
                _id,
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_update/requests/update_affiliate_request.js